import { useEffect, useState } from "react";
import Select from 'react-select';
import { GetInvoiceData } from "../../store/invoiceAtom";




function AddInvoiceProduct(props) {
    const entryData =  GetInvoiceData();
    const [optionList, setOptionList] = useState([]);


  useEffect(()=> {
    if(entryData?.product_type?.length){
      const customOption = entryData?.product_type?.map((item)=> {
        return ({...item, label:`${item.Product_Name}  ${item.Product_Id}`});
      });
      setOptionList(customOption);
    }


  },[entryData]);



  
  const customStyles = {
    control: base => ({
      ...base,
      height: 50,
      backgroundColor: '#F1F1F1',
      width: 450,
    }),
    indicatorSeparator: styles => ({ ...styles, display : 'none' }),
    // placeholder: styles => ({ ...styles, display : 'none' }),
    valueContainer: styles => ({ ...styles, backgroundColor: '',height: 20, paddingBottom:"45px", marginLeft:"13px"}),
    option: styles => ({ ...styles, backgroundColor: '#F1F1F1', color:"black"}),

  
    
  }

    const handleChange = (value) => {
      props.onProductSelect(value)
      };


    return ( 
        <>
   
         <Select   styles={customStyles} onChange={handleChange} 
          defaultValue={props?.defaultVal}
          options={optionList}
         />


        </>
     );
}

export default AddInvoiceProduct;
